import * as XLSX from 'xlsx';

// rows: 2차원 배열(행의 배열). merges: 병합할 범위 배열 [{s:{r,c}, e:{r,c}}, ...] (헤더의 colSpan/rowSpan 표현용)
export function exportRowsToExcel(filename, rows, merges = []) {
  const ws = XLSX.utils.aoa_to_sheet(rows);
  if (merges.length > 0) ws['!merges'] = merges;
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  XLSX.writeFile(wb, filename);
}
